/* eslint-disable */
import { transform } from 'lodash';
import { useRef, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
// material
import {
  Table,
  TableRow,
  TableBody,
  TableCell,
  IconButton,
  Typography,
  TableContainer,
  CircularProgress,
} from '@mui/material';
// component
import Iconify from '../../../components/Iconify';

// ----------------------------------------------------------------------

export default function ChangeHistory({
  item,
}) {
  const ref = useRef(null);
  const { newData, oldData } = item;
  const [mainOpen, setMainOpen] = useState(false);

  const titleCase = (text) => {
    const result = text.replace(/([A-Z])/g, " $1");
    return result.charAt(0).toUpperCase() + result.slice(1);
  }

  return (
    <>
      <IconButton
        ref={ref}
        onClick={() => {
          setMainOpen(true);
        }}
      >
        <Iconify icon="eva:checkmark-circle-2-fill" width={25} height={25} />
      </IconButton>

      <Dialog
        open={mainOpen}
        onClose={() => {
          setMainOpen(false);
        }}
        fullWidth
        maxWidth={'100%'}
      >
        {!mainOpen ? (
          <DialogContent style={{ textAlign: 'center' }}>
            <CircularProgress

            />
          </DialogContent>
        ) : (
          <>
            <DialogTitle id="alert-dialog-title">{'Change History'}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description" style={{ display: 'flex' }}>
                <TableContainer>
                  <Table style={{ minWidth: 600 }}>
                    <TableBody>
                      {Object.entries(newData || {}).map(([key, val]) => {
                        return (
                          key !== 'password' &&
                          key !== 'updatedAt' &&
                          key !== 'id' &&
                          key !== 'userId' && (
                            <TableRow key={key} style={{ margin: 0 }}>
                              <TableCell style={{ margin: 0 }}>
                                <Typography variant="subtitle2">{titleCase(key)}</Typography>
                              </TableCell>
                              <TableCell style={{ margin: 0 }}>
                                {
                                  (key === 'picture' && !!oldData[key]) ? <img src={oldData[key]} alt="user-profile" height={200} /> : <p>-</p>
                                }
                                {
                                  key !== 'picture' && <Typography variant="subtitle2">{typeof oldData[key] === "boolean" ? (oldData[key] ? 'Yes' : 'No') : oldData[key]}</Typography>
                                }
                              </TableCell>
                              <TableCell style={{ margin: 0, backgroundColor: val !== oldData[key] ? '#baff9c' : '' }}>
                                {
                                  (key === 'picture' && !!val) ? <img src={val} alt="user-profile" height={200} /> : <p>-</p>
                                }
                                {
                                  key !== 'picture' && <Typography variant="subtitle2">{typeof val === "boolean" ? (val ? 'Yes' : 'No') : val}</Typography>
                                }
                              </TableCell>
                            </TableRow>
                          )
                        );
                      })}
                    </TableBody>
                  </Table>
                  {!newData && (
                    <div className='text-center'>
                      <h4 className='mt-5'>User Deleted</h4>
                    </div>
                  )}
                </TableContainer>
              </DialogContentText>
            </DialogContent>
            <DialogActions style={{ margin: 10 }}>
              <Button onClick={() => setMainOpen(false)} variant="outlined" style={{ marginRight: 10 }}>
                Cancel
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </>
  );
}
